import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { InfoComponent } from './info.component';

@Injectable({
  providedIn: 'root',
})
export class InfoService {
  private refreshListSource = new Subject<unknown>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}

  open(type: string, config: MatDialogConfig = new MatDialogConfig()) {
    config.minWidth = 'auto';
    config.minHeight = 'auto';
    config.height = '80%';
    config.width = '39%';
    config.data = {
      type: 'ADD',
      ...config.data,
      tipoModal: type,
    };

    const dialogRef = this.dialog.open(InfoComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
        this.emitRefresh(res);
      })
    );
  }

  emitRefresh(data: unknown) {
    this.refreshListSource.next(data);
  }
}
